import { render, staticRenderFns } from "./SkeletonGroups.vue?vue&type=template&id=3d6d2f83"
import script from "./SkeletonGroups.vue?vue&type=script&lang=js"
export * from "./SkeletonGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d6d2f83')) {
      api.createRecord('3d6d2f83', component.options)
    } else {
      api.reload('3d6d2f83', component.options)
    }
    module.hot.accept("./SkeletonGroups.vue?vue&type=template&id=3d6d2f83", function () {
      api.rerender('3d6d2f83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/account/views/groups/components/SkeletonGroups.vue"
export default component.exports